import { PermitTypeBase } from './base/permit-type-base';

export class PermitType extends PermitTypeBase { }